<template>
  <div class="container-bo-test">
    <div class="container-bo-test" v-if="!this.submitFlg">
      <div class="page">
        <div class="page-ct">
          <ul class="test-steps clearfix" v-show="!this.confirmFlg">
            <li class="active">{{$t("bo.test.step1")}}</li>
            <li>{{$t("bo.test.step2")}}</li>
            <li>{{$t("bo.test.step3")}}</li>
          </ul>
          <ul class="test-steps clearfix" v-show="this.confirmFlg">
            <li>{{$t("bo.test.step1")}}</li>
            <li class="active" v-show="this.confirmFlg">{{$t("bo.test.step2")}}</li>
            <li>{{$t("bo.test.step3")}}</li>
          </ul>
          <ul class="test-steps clearfix" v-show="this.submitFlg">
            <li>{{$t("bo.test.step1")}}</li>
            <li>{{$t("bo.test.step2")}}</li>
            <li class="active" v-show="this.submitFlg">{{$t("bo.test.step3")}}</li>
          </ul>
          <hr>
          <p ref="errorMessage" class="alert alert-danger" v-if="this.model.errorMessage != null">{{$t(model.errorMessage)}}</p>
          <p class="text-danger" v-if="this.model.errorMessage == null && !this.confirmFlg" >{{$t("nts.ams.fe.testbo.agree")}}</p>
          <h3 id="titleBoTest" v-if="!this.confirmFlg">{{$t("nts.ams.fe.testbo.checkinfo")}}</h3>
          <div class="panel-agreement" v-if="!this.confirmFlg">
            <div class="section">
              <div class="section-box">
                <div class="left-part">
                  <div class="section-box-item">
                  <ol class="term-condition">
                    <li>{{$t("nts.ams.fe.testbo.legal1")}} </li>
                    <li>{{$t("nts.ams.fe.testbo.legal2")}} </li>
                    <li>{{$t("nts.ams.fe.testbo.legal3")}} </li>
                    <li>{{$t("nts.ams.fe.testbo.legal4")}} </li>
                    <li>{{$t("nts.ams.fe.testbo.legal5")}} </li>
                    <li>{{$t("nts.ams.fe.testbo.legal6")}} </li>
                  </ol>
                </div>
              </div>
              <div class="right-part" :class="this.isBack ?'selected':''" id="agreeTest">
                <div class="section-item-action">
                  <button class="btn btn-warning btn-select" @click="agreeTest()">{{$t("btn.agreeTest")}}</button>
                  <span>&nbsp;</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h3>{{$t("nts.ams.fe.testbo.questionTitle")}}</h3>
        <div class="box bg-white" >
          <div class="box-ct">
            <form class="form-horizontal form-question-list">
              <div class="question-group" v-for="subject in this.model.questionSort" :key="subject.key">
                <div class="question-group">
                  <p class="group-heading"><strong>{{$t(textMapSubject[subject])}}</strong></p>
                  <div class="question-item bg-white p-0" v-for="boTestInfo in model.boTestInfoGroup[subject]" :key="boTestInfo.key">
                    <div class="question-item pt-4">
                      <div class="form-group overflow-auto">
                        <div class="col-xl-9 col-md-8 float-left">
                          <div class="question-ct">
                            <p><span v-html="(boTestInfo.question)" style="word-wrap: break-word;"></span></p>
                          </div>
                        </div>
                        <div class="col-xl-3 col-md-4 float-left">
                          <div class="question-action">
                            <button type="button" class="btn btn-hint" data-toggle="collapse"  :data-target="'#hint' + boTestInfo.questionId"
                                    :disabled="!agreeTestFlg || confirmFlg">
                              {{$t("bo.test.button.hints")}}
                            </button>
                            <label class="radio-inline">
                              <input type="radio" :class="boTestInfo.customerAnswer == 1?'selected-question':''" :name="boTestInfo.questionId" value="1"
                                     @click="isCheckedAll()" v-model="boTestInfo.customerAnswer" :disabled="!agreeTestFlg || confirmFlg">
                              <div class="btn btn-default radio-img" :class="boTestInfo.customerAnswer == 1?'selected-question':''" >{{$t("radio.yes")}}</div>
                            </label>
                            <label class="radio-inline">
                              <input type="radio" :class="boTestInfo.customerAnswer == 2?'selected-question':''" :name="boTestInfo.questionId" value="2"
                                     @click="isCheckedAll()" v-model="boTestInfo.customerAnswer" :disabled="!agreeTestFlg || confirmFlg">
                              <div class="btn btn-default radio-img" :class="boTestInfo.customerAnswer == 2?'selected-question':''">{{$t("radio.no")}}</div>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="collapse" :id="'hint' + boTestInfo.questionId">
                        <p class="question-hint"><b>{{$t("bo.test.label.hints")}}</b>
                          <br>
                          <span v-html="(boTestInfo.hintLink)" style="word-wrap: break-word;"></span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="question-submit text-center">
                <button id="btt-confirm" class="btn btn-lg center-block" @click.prevent="confirmTest()" v-show="!this.confirmFlg" disabled="disabled">
                  {{this.confirmTestTextButton}}
                </button>
                <button class="btn btn-primary btn-lg mr-1" type="button" v-if="this.confirmFlg" @click.prevent="modifyTest()">
                  {{$t("btn.modify")}}
                </button>
                <button id="btt-submit" class="btn btn-success btn-lg ml-1" type="button" @click.prevent="submitTest()" v-if="confirmFlg">
                  {{$t("btn.determination")}}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div class="container-bo-test" v-if="this.submitFlg">
      <div class="page">
        <div class="page-ct">
          <ul class="test-steps clearfix">
            <li class="complete">{{$t("bo.test.step1")}}</li>
            <li class="complete">{{$t("bo.test.step2")}}</li>
            <li class="active">{{$t("bo.test.step3")}}</li>
          </ul>
          <hr>
          <div class="box bg-white">
            <div class="test-result">
              <p v-if="this.model.url == null" v-html="$t('bo.test.result.fail')"></p>
              <p v-if="this.model.url != null" v-html="$t('bo.test.result.success', { company_tel: this.telephone })"></p>
              <div class="row">
                <div class="col-md-6">
                  <table class="table table-striped mark-detail">
                    <thead>
                    <tr :class="this.model.url != null?'bg-success':'bg-danger'">
                      <th>{{$t("bo.test.th.result")}}</th>
                      <th class="text-right">{{this.model.totalAnswer}}{{$t("nts.ams.fe.testbo.correct_answer")}}/{{this.model.totalQuestion}}{{$t("nts.ams.fe.testbo.correct_answer")}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in this.model.listBoTestResult" :key="item.key">
                      <td>{{$t(textMapSubject[item.subject])}}</td>
                      <td class="text-right">{{item.correctAnswer}}{{$t("nts.ams.fe.testbo.correct_answer")}}/{{item.totalAnswer}}{{$t("nts.ams.fe.testbo.total_answer")}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="action text-center">
              <a class="btn btn-lg btn-success" @click="backToHome()">{{$t("btn.mypage")}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import IConstants from "@/common/constants/IConstants";
import ModalPlugin from "../../common/plugins/ModalPlugin";
import ServiceUtils from "@/common/utils/ServiceUtils.js";
import offModalEvent from "@/common/mixins/offModalEvent";
import * as HEADER_TYPE from "@/store/modules/header/type";
import * as NEWS_TYPE from "@/store/modules/news/type";
import {createNamespacedHelpers} from "vuex";
import postDocTemplateMixin from "@/common/mixins/postDocTemplate";

const {mapActions: mapHeaderAction} = createNamespacedHelpers("header");
const {mapActions: mapNewsActions} = createNamespacedHelpers('news');

export default {
    data() {
        return {
            SERVICE_NAME: "boTest",
            textMapSubject: IConstants.getMapQuestionSubject(),
            model: {
                listTest: [],
                questionSort: [],
                boTestInfoGroup: [],
                listBoTestResult: [],
                errorMessage: null,
                successMessage: null,
                url: null,
                totalAnswer: 0,
                totalQuestion: 0
            },
            confirmFlg: false,
            agreeTestFlg: false,
            submitFlg: false,
            confirmTestTextButton: '',
            REQUEST_SCREEN: 'bo-test',
            TEST_STATUS: 0,
            IS_GET_NEWS: false,
            isBack: false
        }
    },
    mixins: [offModalEvent, postDocTemplateMixin],
    beforeMount() {
        this.confirmTestTextButton = this.$t("btn.confirmTest");
        this.afterCloseInformModal();
        this.afterCloseTestDisabledModal();

        if (this.$route.query.testStatus !== 2) {
            this.agreeBoTest();
        }

        if (this.model.errorMessage) {
            this.$refs.errorMessage.focus();
        }
    },
    mounted() {
        this.isCheckedAll();
    },
    watch: {
        telephone() {
            this.checkTestStatus();
        }
    },
    destroyed() {
        this.offEventName(this.IConstants.EVENT_NAME.CLOSE_INFORM_MODAL);
        this.offEventName(this.IConstants.EVENT_NAME.CLOSE_TEST_DISABLED_MODAL);
    },
    methods: {
        ...mapHeaderAction([HEADER_TYPE.SET_DISPLAY_OFF_CANVAS_BTN]),
        ...mapNewsActions([NEWS_TYPE.FORCE_SET_AGREE_FLG]),
        
        afterCloseInformModal() {
            ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.CLOSE_INFORM_MODAL, () => {
                this.backToHome();
            })
        },

        afterCloseTestDisabledModal() {
            ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.CLOSE_TEST_DISABLED_MODAL, () => {
                this.backToHome();
            })
        },

        backToHome: function () {
            this.$router.push({name: "home"});
        },

        checkTestStatus: function () {
            this.TEST_STATUS = this.$route.query.testStatus;
            if (this.TEST_STATUS === '2') {
              const params = {
                telephone: this.telephone
              }

              this.$modal.openTestDisabledModal(params);
            }
        },

        async agreeBoTest() {
            await this.$service.getService(this.SERVICE_NAME).agreeBoTest().then((response) => {
                this.model = response;
                this.TEST_STATUS = response.testToday;
                if (response.testToday === 1) {
                    let today = response.startDateTest;
                    const message = today + this.$t("nts.ams.fe.testbo.warning");
                    this.$modal.openInformModal(message);
                } else if (response.testToday === 2) {
                  const params = {
                    telephone: this.telephone
                  }

                  this.$modal.openTestDisabledModal(params);
                }
            });
        },

        agreeTest: function () {
            if (this.agreeTestFlg) {
                this.agreeTestFlg = false;
                $("#agreeTest").removeClass('selected');
                $(".question-item").removeClass('ready');
                $("#btt-confirm").attr("disabled", "disabled");
                this.confirmTestTextButton = this.$t("btn.confirmTest");
            } else {
                this.agreeTestFlg = true;
                $(".question-item").addClass('ready');
                $("#agreeTest").addClass('selected');
                this.isCheckedAll();
            }
        },

        async confirmTest() {
            $("#btt-confirm").prop('disabled', true);
            if (!this.isCheckedAll()) {
                return;
            }
            let listTest = [];
            const questionSort = this.model.questionSort;
            for (let i = 0; i < questionSort.length; i++) {
                let listBoTest = this.model.boTestInfoGroup[questionSort[i]];
                for (let j = 0; j < listBoTest.length; j++) {
                    listTest.push(listBoTest[j]);
                }
            }
            let data = ServiceUtils.convertObjectToList("listTest", listTest);
            data["startDateTest"] = this.model.startDateTest;
            const config = {
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            };
            const dataTransformed = this.transformRequest(data);
            await this.$service.getService(this.SERVICE_NAME).confirmBoTest(dataTransformed, config).then((response) => {
                this.model = response;
                if (response.errorMessage == null) {
                    this.confirmFlg = true;
                    $('#titleBoTest').hide();
                }
            }).catch((response) => {
                console.log(response);
            });
            setTimeout(function () {
                $("#btt-confirm").prop('disabled', false);
            }, 3000);
        },

        isCheckedAll: function () {
            let selectAll = $('input[type=radio]:checked').length;
            if (this.model && selectAll === this.model.listTest.length) {
                $("#btt-confirm").removeAttr("disabled");
                $("#btt-confirm").addClass("allanswerd btn-success");
                this.confirmTestTextButton = this.$t("btn.go_to_confirm");
                return true;
            } else {
                $("#btt-confirm").removeClass("allanswerd btn-success");
                $("#btt-confirm").attr("disabled", "disabled");
                this.confirmTestTextButton = this.$t("btn.confirmTest");
                return false;
            }
        },

        modifyTest: function () {
            this.confirmFlg = false;
            this.agreeTestFlg = true;
            this.isCheckedAll();
            this.isBack = true;
            this.model.errorMessage = null;
            this.model.successMessage = null;
        },

        submitTest: function () {
            $("#btt-submit").prop('disabled', true);
            if (!this.isCheckedAll) {
                return;
            }
            let listTest = [];
            const questionSort = this.model.questionSort;
            for (let i = 0; i < questionSort.length; i++) {
                let listBoTest = this.model.boTestInfoGroup[questionSort[i]];
                for (let j = 0; j < listBoTest.length; j++) {
                    listTest.push(listBoTest[j]);
                }
            }
            let data = ServiceUtils.convertObjectToList("listTest", listTest);
            data["startDateTest"] = this.model.startDateTest;
            const config = {
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            };
            const dataTransformed = this.transformRequest(data);
            this.$service.getService(this.SERVICE_NAME).submitBoTest(dataTransformed, config).then((response) => {
                this.model = response;
                if (response.errorMessage == null) {
                    this.submitFlg = true;
                    this.agreeTestFlg = false;
                    this.confirmFlg = false;
                }
            });
            setTimeout(function () {
                $("#btt-submit").prop('disabled', false);
            }, 3000);
        },
        transformRequest: function (obj) {
            let str = [];
            for (let index in obj)
                str.push(encodeURIComponent(index) + "=" + encodeURIComponent(obj[index]));
            return str.join("&");
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm[NEWS_TYPE.FORCE_SET_AGREE_FLG](true);
            vm[HEADER_TYPE.SET_DISPLAY_OFF_CANVAS_BTN](false);
        });
    },
    beforeRouteLeave(to, from, next) {
        this[NEWS_TYPE.FORCE_SET_AGREE_FLG](false);
        this[HEADER_TYPE.SET_DISPLAY_OFF_CANVAS_BTN](true);
        next();
    },
}

</script>

<style scoped>
  .form-question-list .question-item {
    border-bottom: 1px solid #ddd;
    padding: 10px 0;
  }
  .container-bo-test {
    margin-right: auto;
    margin-left: auto;
  }
  @media (min-width: 1200px) {
    .container-bo-test {
      width: 1140px;
    }
  }
</style>
